module.exports = {"discount_cookie":"ww_discount_final3","cart_id":"ww_cart_id_4"}


//////////////////
// WEBPACK FOOTER
// ./src/utils/cookie.json
// module id = 78
// module chunks = 28313394369846 114276838955818